import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { changeLocationHard } from '../../actions/common';
import { SidebarLinksMenuLink } from '../../components/Sidebar/SidebarLinksMenu/SidebarLinksMenu';
import { SidebarInfoMenu, SidebarInfoMenuProps } from '../../components/SidebarInfoMenu/SidebarInfoMenu';
import { selectFooterData } from '../../selectors/footer/footer';
import { selectSidebarInfoMenuLinks } from '../../selectors/sidebar/sidebar';
import { LinkTarget } from '../../typings/common';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

interface OwnProps {
    links?: SidebarLinksMenuLink[];
}

type StateProps = TStateProps<SidebarInfoMenuProps>;

interface DispatchProps {
    changeLocation: (url: string) => void;
}

type MergedProps = SidebarInfoMenuProps;

const mapStateToProps = (state: State): StateProps => {
    const footer = selectFooterData(state);
    const links = selectSidebarInfoMenuLinks(state);

    return {
        contacts: footer.contacts,
        manager: footer.manager,
        links
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        changeLocation(url: string) {
            dispatch(changeLocationHard(url, LinkTarget.blank));
        }
    };
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): MergedProps => {
    return {
        ...stateProps,
        links: [
            ...(ownProps.links || []),
            ...stateProps.links.map((el: SidebarLinksMenuLink & { href: string }) => ({
                ...el,
                onClick: () => dispatchProps.changeLocation(el.href)
            }))
        ]
    };
};

export const SideInfoMenuContainter = connect<StateProps, DispatchProps, OwnProps, MergedProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(SidebarInfoMenu);
